import { getMakeAPI, Method } from '@golden/getch';
import { createBranch } from '../utils/ServiceUtils';
import { Branch } from '../enums/Branch';
import { CaptchaServiceType } from '../enums/CaptchaServiceType';
const makeAPI = getMakeAPI('v1');
export const CONFIG_API = {
    GET_CONFIG: makeAPI(Method.GET, 'configs')()
};
export function createConfigService(api, trunk) {
    return {
        config: createBranch({
            trunk,
            branch: Branch.CONFIG,
            value: {
                captcha_enabled: false,
                captcha_type: CaptchaServiceType.BOTION
            },
            operator: () => api.fetch(CONFIG_API.GET_CONFIG)
        }),
        get() {
            return api.fetch(CONFIG_API.GET_CONFIG);
        }
    };
}
//# sourceMappingURL=ConfigService.js.map